export function SineWaveDashedLine({
  width = 800,
  height = 400,
  amplitude = 160,
  strokeWidth = 2,
  dashArray = "8 6",
  color = "white",
  backgroundColor = "transparent",
  opacity = 1,
}) {
  const midY = height / 2;
  const quarterW = width / 4;

  const path = [
    `M 0 ${midY}`,
    `Q ${quarterW} ${midY - amplitude}, ${width / 2} ${midY}`,
    `Q ${quarterW * 3} ${midY + amplitude}, ${width} ${midY}`,
  ].join(" ");

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        minHeight: height,
        backgroundColor,
        opacity,
      }}
    >
      <svg
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        xmlns="http://www.w3.org/2000/svg"
        style={{ overflow: "visible" }}
      >
        <path
          d={path}
          fill="none"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeDasharray={dashArray}
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
}
